// member
if ($('.block--download_tabs').length) {
	// Show the first tab and hide the rest
	$('.tabs--left li:first-child').addClass('active');
	$('.tab-content .tab-pane').hide();
	$('.tab-content .tab-pane:first').show();

	// Click function
	$('.tabs--left li').click(function () {
		$('.tabs--left li').removeClass('active');
		$(this).addClass('active');
		$('.tab-content .tab-pane').hide();

		var activeTab = $(this).find('a').attr('href');
		$(activeTab).fadeIn();
		return false;
	});

	$('.tabs--left li').each(function () {
		var activeTab = $(this).find('a').attr('href');

		if (window.location.href.indexOf(activeTab) > 0) {
			$('.tabs--left li').removeClass('active');
			$(this).addClass('active');
			$('.tab-content .tab-pane').hide();
			$(activeTab).fadeIn();
		}
	});

	$('.nav--tabs--mobile').change(function () {
		$('.tab-content .tab-pane').hide();
		var activeTab = $(this).val();
		$(activeTab).fadeIn();
		$('.tabs--left li').removeClass('active');
	});
}


 var eyetoggle = document.createElement('img');
 eyetoggle.setAttribute('class','eye-toggle');
 eyetoggle.setAttribute('src','/wp-content/themes/localmedia/symbols/icon-eye.svg');
 document.addEventListener('click', function(e) {
  var passwordinput = $(e.target).prev()[0];
  if(passwordinput) {
    if(passwordinput.getAttribute('type') == 'password') {
      passwordinput.setAttribute('type','text');
    }
    else {
      passwordinput.setAttribute('type','password');
    }
  }
 }, { passive: false });

 $('.lwa-password-input input').each(function() {
  this.setAttribute('autocomplete','off');
 });
 $('.lwa-password-input').append(eyetoggle);
